import { graphql } from 'react-relay';

import { MATSalesRecordWindowPaginator_query$key } from '../../../relay/__generated__/MATSalesRecordWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const MATSalesRecordWindowPaginator_query = graphql`
  fragment MATSalesRecordWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: MATSalesRecordFilter }
    order: { type: MATSalesRecordOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "MATSalesRecordWindowPaginatorRefreshQuery") {
    salesRecords(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...MATSalesRecordConnectionDataTable_matSalesRecordConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<MATSalesRecordWindowPaginator_query$key>, 'fragment'>;

const MATSalesRecordWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={MATSalesRecordWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.salesRecords.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default MATSalesRecordWindowPaginator;
